import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="font-display text-white text-2xl md:text-3xl mb-4">{title}</h2>
    <div className="text-[#A0A0A0] leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="privacy-page">
      <div className="mx-auto max-w-3xl px-5 md:px-10 py-16 md:py-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-[#666] hover:text-white transition-colors font-mono-accent text-xs mb-12"
          data-testid="privacy-back"
        >
          <ArrowLeft size={14} /> Back to site
        </Link>

        <p className="font-mono-accent text-[#005EEA] text-xs mb-4">Legal</p>
        <h1 className="font-display text-white text-4xl md:text-6xl leading-none mb-4">Privacy Policy</h1>
        <p className="text-[#555] font-mono-accent text-[10px] mb-14">Last updated: December 2025</p>

        <Section title="Who we are">
          <p>
            This website is operated by <span className="text-white">Getfitwithjeanclaude</span> ("we",
            "us"). We provide personal training, strength &amp; conditioning, and bootcamp coaching
            services. You can reach us at{" "}
            <a href="mailto:getfitwithjeanclaude@gmail.com" className="text-[#005EEA] hover:underline">
              getfitwithjeanclaude@gmail.com
            </a>
            .
          </p>
        </Section>

        <Section title="What we collect">
          <p>When you submit a consultation request, we collect the information you provide:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Your name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Your fitness goals and any message you choose to share</li>
            <li>The program you're interested in</li>
          </ul>
        </Section>

        <Section title="How we use it">
          <p>We use your information only to:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Respond to your consultation request and contact you about coaching</li>
            <li>Send you a confirmation email and, where relevant, a payment invoice</li>
            <li>Provide and improve our coaching services</li>
          </ul>
          <p>We do not sell or rent your personal information to third parties.</p>
        </Section>

        <Section title="Payments">
          <p>
            Payments are processed securely by <span className="text-white">Square</span> and, where
            offered, <span className="text-white">Afterpay</span>. We never see or store your full card
            details — these are handled directly by our payment providers under their own privacy terms.
          </p>
        </Section>

        <Section title="Your choices">
          <p>
            You can ask us to access, correct, or delete the personal information we hold about you at
            any time by emailing{" "}
            <a href="mailto:getfitwithjeanclaude@gmail.com" className="text-[#005EEA] hover:underline">
              getfitwithjeanclaude@gmail.com
            </a>
            . You may also opt out of any future communications at any time.
          </p>
        </Section>

        <Section title="Changes">
          <p>
            We may update this policy from time to time. Any changes will be posted on this page with a
            revised date above.
          </p>
        </Section>
      </div>
    </div>
  );
}
